import { render, staticRenderFns } from "./register-simple-form.vue?vue&type=template&id=3fc3bc8e&scoped=true&"
import script from "./register-simple-form.vue?vue&type=script&lang=js&"
export * from "./register-simple-form.vue?vue&type=script&lang=js&"
import style0 from "./register-simple-form.vue?vue&type=style&index=0&id=3fc3bc8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc3bc8e",
  null
  
)

export default component.exports